import type { SupportArea } from "@lms/shared-types";

/** A first guess at what a request is about, from the page it was sent on; the person can change it. */
export function guessArea(route: string): SupportArea {
  const path = route.split(/[?#]/)[0] ?? route;
  if (/^\/training(\/|$)/.test(path)) return "training";
  if (/^\/account(\/|$)/.test(path)) return "account";
  if (/^\/(login|auth)(\/|$)/.test(path)) return "sign_in";
  if (/^\/program\/users(\/|$)/.test(path)) return "people";
  if (/^\/program\/audit(\/|$)/.test(path)) return "audit";
  if (/^\/docs(\/|$)/.test(path)) return "docs";
  return "other";
}
